import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dropdown-usage',
  templateUrl: './dropdown-usage.component.html',
  styleUrls: ['./dropdown-usage.component.sass']
})
export class DropdownUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
